<svelte:options
	customElement={{
		tag: "favorite-button",
		shadow: "none",
	}}
/>

<script lang="ts">
	import { tippy } from "svelte-tippy";
	import { Toast } from "@wagich/svelma";
	import SvgIcon from "@/common/svg-icon.svelte";
	import { favoriteIds } from "./store";
	import { type Id } from "@/api";
	import { track } from "@plausible-analytics/tracker";

	export let eventid: Id;
	export let eventname: string;
	export let companyname: string;

	$: isSelected = $favoriteIds.includes(eventid);
	$: tooltipText = isSelected ? "Aus Merkliste entfernen" : "Zu Merkliste hinzufügen";

	function toggle() {
		if (isSelected) {
			favoriteIds.update((ids) => ids.filter((id) => id !== eventid));
			Toast.create({ message: "Veranstaltung aus der Merkliste entfernt." });
			try {
				track("Merkliste", { props: { Name: eventname, Partner: companyname } });
			} catch {}
		} else {
			favoriteIds.update((ids) => [...ids, eventid]);
			Toast.create({ message: "Veranstaltung zur Merkliste hinzugefügt." });
		}
	}
</script>

<button class="button is-circle is-medium is-primary is-inverted" on:click|preventDefault={toggle} aria-label={tooltipText} use:tippy={{ content: tooltipText }}>
	{#if isSelected}
		<SvgIcon name="interface-favorite-heart" size="is-medium" />
	{:else}
		<SvgIcon name="interface-favorite-heart-outline" size="is-medium" />
	{/if}
</button>
